import { listen } from "ol/events";
import Map from "ol/Map";
import MapEventType from "ol/MapEventType";
import ScaleLine from "ol/control/ScaleLine";
import { ScreenDPI } from "@/common/utils";

const INCHES_PER_METER = 39.37;
let DOTS_PER_INCH = 96;

export class Scale extends ScaleLine {
  //following three are private in ScaleLine
  private target_: Element;
  private map_: Map;
  private viewState_: any;
  //additional element to show scale value as 1:xxxx
  private valueElement_: Element;

  constructor(options) {
    super(options);
    this.listenerKeys = [];
    if (options.showScale!==false) {
      this.valueElement_ = document.createElement('DIV');
      this.valueElement_.className = 'ol-scale-value';
    }
    let dpi = ScreenDPI();
    DOTS_PER_INCH = dpi.x || DOTS_PER_INCH;
  }

  setMap(map:Map) {
    super.setMap(map);
    //this.map = map;
    if (this.map_) {
      // this.target_ is set in super.setMap()
      //var target = this.target_ ? this.target_ : map.getOverlayContainerStopEvent();
      if (this.valueElement_) {
        this.target_.appendChild(this.valueElement_);
      }
      this.listenerKeys.push(listen(map, MapEventType.POSTRENDER, this.render, this));
      map.render();
    }
  }

  render(mapEvent:Event) : boolean {
    //Event shoule be a MapEventType
    let frameState = mapEvent['frameState'];
    
    if (frameState == null) {
      this.viewState_ = null;
    } else {
      this.viewState_ = frameState.viewState;
    }
    this.updateElement_();
    return true;
  }
  
  private updateElement_() {
    if (this.viewState_) {
      if (super['updateElement_']) {
        super['updateElement_']();
      }
      let resolution = this.viewState_.resolution;
      let projection = this.viewState_.projection;
      let pointResolution = projection.getMetersPerUnit() * resolution;
      if (this.valueElement_) {
      let scale = Math.round(pointResolution * DOTS_PER_INCH * INCHES_PER_METER);
          this.valueElement_.innerHTML = "1:" + Math.round(scale).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    }
  }
}